module.exports = __webpack_public_path__ + "img/miaowang-banner.cfad869b.png";